import { jsx } from 'react/jsx-runtime';
import { createContext, useState, useContext } from 'react';
import { noop } from '../utils/fn.js';

const ScrubbableInputValueContext = createContext(null);
const ScrubbableInputSetterContext = createContext(noop);
/** Get the current scrubbable input context. */
function useScrubbableInputContext() {
    return useContext(ScrubbableInputValueContext);
}
/** Get a setter to update the current scrubbable input context. */
function useSetScrubbableInputContext() {
    return useContext(ScrubbableInputSetterContext);
}
/** Context for registering and passing around the current state of a FormattedInput. */
function ScrubbableInputContext({ children }) {
    const [ctx, setCtx] = useState(null);
    return (jsx(ScrubbableInputValueContext.Provider, { value: ctx, children: jsx(ScrubbableInputSetterContext.Provider, { value: setCtx, children: children }) }));
}
ScrubbableInputContext.displayName = 'ScrubbableInputContext';

export { ScrubbableInputContext, useScrubbableInputContext, useSetScrubbableInputContext };
//# sourceMappingURL=scrubbable-input.context.js.map
